var map = {
	"./033-bm.webp": 1269,
	"./033-cn.webp": 1270,
	"./033.webp": 1271,
	"./13-bm.webp": 1272,
	"./13-cn.webp": 1273,
	"./13.webp": 1274,
	"./3-bm.webp": 1275,
	"./3-cn.webp": 1276,
	"./3.webp": 1277,
	"./angpao-bg-mobile.webp": 1278,
	"./angpao-bg.webp": 1279,
	"./angpao-bm.webp": 1280,
	"./angpao-cn.webp": 1281,
	"./angpao.webp": 1282
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1268;